export default __webpack_public_path__ + "static/personalized_popup-793dedf31514d4c1c64ad6d0a04eff2d.png";